module.exports = new __parcel__URL__("progress-in-idea.36378d24.svg").toString();